import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs/internal/Subscription';
import { FamilyInviationService } from 'src/app/Service/familyinviation.service';
import { LoadingService } from 'src/app/Service/loading.service';

@Component({
    selector: 'app-decline',
    templateUrl: './decline.component.html',
    styleUrls: ['../../Executor/executor.component.css'],
    standalone: false
})
export class DeclineComponent {
  subscription = new Subscription();
  constructor(
    public activeModal: NgbActiveModal,
    public loaderService: LoadingService,
    public familyInviationService: FamilyInviationService
  ) {
    this.loaderService.HideLoading();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
 
}
